var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { animated } from '@react-spring/web';
import { useSpringValues } from '../hooks/use-spring-values';
import { useStaticColors } from '../hooks/use-theme-colors';
var cls = classNames('svg-circle');
export var SvgCircleDefaultProps = {
  onClick: function () {},
  onMouseOver: function () {},
  strokeWidth: 2,
  opacity: 1,
  cx: 0,
  cy: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isActive = _a.isActive,
      colors = _a.colors;
    return theme.STROKE_FILL_COLORS({
      colors: colors,
      isActive: isActive,
      autoTransitions: true,
      selector: cls.child('circle')
    });
  })
});
// -------- Components -------->
var My = {
  Container: styled(animated.svg)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Circle: styled(animated.circle).attrs(cls.attr('circle'))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SvgCircle = function (props) {
  var className = props.className,
    onClick = props.onClick,
    onMouseOver = props.onMouseOver,
    children = props.children,
    strokeDasharray = props.strokeDasharray,
    isActive = props.isActive,
    colors = props.colors,
    id = props.id;
  var values = useSpringValues(props);
  // resolve theme colors for direct attributes.
  // direct attributes are best for static colors, as they are more portable for exports. 
  var staticColors = useStaticColors(props.colors, {
    isActive: isActive
  });
  return React.createElement(My.Container, {
    id: id,
    overflow: 'visible',
    onClick: onClick,
    onMouseOver: onMouseOver,
    isActive: isActive,
    colors: props.colors,
    className: cls.name(className)
  }, React.createElement(My.Circle, {
    opacity: values.opacity,
    fill: staticColors.fill || 'none',
    stroke: staticColors.stroke || 'none',
    r: values.r,
    cx: values.cx,
    cy: values.cy,
    strokeWidth: values.strokeWidth,
    strokeDasharray: strokeDasharray
  }), children);
};
SvgCircle.cls = cls;
SvgCircle.defaultProps = SvgCircleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;